const forms = require('./forms');
const humanize = require('./humanize');
const breadcrumbs = require('./breadcrumbs');
const sharedStatus = require('./sharedStatus');
const pageTitle = require('./pageTitle');
const uiPopupHints = require('./popup-hints-for-ui');
const constants = require('./constants');
const emailConfirmation = require('./emailConfirmation');
const serverErrors = require('./serverErrors');

module.exports = {
  forms,
  humanize,
  breadcrumbs,
  sharedStatus,
  pageTitle,
  uiPopupHints,
  constants,
  emailConfirmation,
  serverErrors,
};
